import { MaintenanceItem } from '../../../models/DTOs/maintenance/maintenanceItem/Model';
import { ServiceError } from '../helperTypes';
import { Service } from '../Service';

export abstract class IMaintenanceItemService extends Service {
  abstract getByOrganizationId(): Promise<MaintenanceItem[] | ServiceError>;
  abstract getAlertTypes(): Promise<MaintenanceItem[] | ServiceError>;
}
